export const normalizePositiveIntegerId = value => {
	const id = Number(value);

	return Number.isSafeInteger(id) && id > 0 ? id : undefined;
};

export const normalizeDatasourceAccessId = normalizePositiveIntegerId;

export const ORDER_OVERVIEW_MODES = Object.freeze({
	DATASOURCE: 'datasource',
	RESOURCE: 'resource',
});
